import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/src/app/why-choose-us/components/CaseStudyCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/src/components/ui/AppImage.tsx");
